export const commonReportColumn = [
  {
    Header: "Nome",
    accessor: "name",
  },
  {
    id: "action",
    Header: "Ações",
    accessor: "action",
  },
];

